// extracted by mini-css-extract-plugin
export default {"withoutDialog":"oxSKh7","withDialog":"zHvOHu"};